import { QUESTION_INDEX_TO_FIELDS_ADULT } from './questions.adult';
import { QUESTION_INDEX_TO_FIELDS_EDUCATOR } from './questions.educator';
import { QUESTION_INDEX_TO_FIELDS_EMPLOYER } from './questions.employer';
import { QUESTION_INDEX_TO_FIELDS_STUDENT } from './questions.student';
import { OnboardingFlow } from '../onboarding.types';

export const getFieldToQuestionIndex = (onboardingType: OnboardingFlow) => {
  const configMap: Record<OnboardingFlow, Record<number, string[]>> = {
    student: QUESTION_INDEX_TO_FIELDS_STUDENT,
    adult: QUESTION_INDEX_TO_FIELDS_ADULT,
    educator: QUESTION_INDEX_TO_FIELDS_EDUCATOR,
    employer: QUESTION_INDEX_TO_FIELDS_EMPLOYER,
  };

  const FIELD_TO_QUESTION_INDEX = Object.entries(configMap[onboardingType]).reduce(
    (acc, [indexString, fields]) => {
      const index = Number(indexString);

      for (const field of fields) {
        acc[field] = index;
      }

      return acc;
    },
    {} as Record<string, number>,
  );

  return FIELD_TO_QUESTION_INDEX;
};
